export const format2Decimals = value =>
    (value?.toString().match(/^-?\d+(?:\.\d{0,2})?/) || [''])[0];

export const formatPrice = (value, locale = 'en', currency = 'EUR') => {
    if(value === undefined) return '-'
    return parseFloat(value).toLocaleString(locale, {
        style: 'currency',
        currency,
        currencyDisplay: 'code'
    });
};

export const formatPriceNoCurrency = (value, locale = 'en') => {
    if(value === undefined) return '-'
    return parseFloat(value).toLocaleString(locale, {
        minimumFractionDigits: 2
    });
};
